<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <!--<footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>COPYRIGHT &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="https://1.envato.market/vuexy_admin" target="_blank" rel="nofollow">GetBoarded</a>
          <span class="hidden sm:inline-block">, All rights Reserved</span>
        </p>
        <span class="md:flex hidden items-center">
            <span>Hand-crafted & Made with</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
        </span>
    </footer>-->

  <footer v-if="organizationSlug==='gala' || organizationSlug==='emotionhack'" :style="{ background: '#ffffff'}">

    <section
      class="container"
    >

      <vs-row  vs-w="12">

        <vs-col
          class="footer-copyright"
          :style="{ color: alexPage ? 'black' : 'black' }"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
          style="font-size:12px;margin-bottom: 10px;"
        >
          © {{ new Date().getFullYear() }} GetBoarded INC | <router-link class="text-black" to="/privacy-policy">Privacy </router-link> |
          <router-link class="text-black" to="/cookie-policy">Cookies</router-link> | <router-link class="text-black" to="/terms-of-use">T & C</router-link> | <router-link class="text-black" to="/gdpr-compliance">GDPR Compliance</router-link>
        </vs-col>
      </vs-row>
    </section>
  </footer>
  <footer
    v-else
    class="footer"
    id="footer"
    :style="{ background: pageFooterBackgroundColor }"
  >
<vs-card
      v-if="pageType === 'company'"
      class="newsletter-card newsletter-card--company p-5"
    >
      <div>
        <h3 class="mb-5">Help & Support</h3>
        <p class="mb-base">
          Each organization has their own model of employee training and
          engagement model. We bring in our consultancy approach to your
          organization and respond with a custom solution with our plugin APIs.
          Being useful is our main priority. Our 24/7 support team is here to
          help you and make sure our services help you grow. Have a presale
          question about our products and features? We would love to hear from
          you. Get our media resources and learn about our company information.
        </p>
        <vs-button color="#F29300" style="border-radius: 50px"
          >DOWNLOAD BROCHURE</vs-button
        >
      </div>
    </vs-card>
    <vs-card
      v-else-if="pageType === 'alex' && organizationSlug==='dpd-belux'"
      class="newsletter-card my-suggestions-card p-5"
    >
      <div>
        <h3 class="mb-5 text-center">{{ $t("alex.mySuggestions") }}</h3>
        <p class="mb-base text-center">
          {{
            $t("alex.mySuggestionsDesc", {
              orgName: organizationName,
            })
          }}
        </p>
        <div class="text-center">
          <vs-button
            color="#dc0032"
            style="border-radius: 50px"
            @click="showChatPopup"
            >{{ $t("alex.mySuggestionsSubmit") }}</vs-button
          >
        </div>
      </div>
    </vs-card>
    <vs-card
      v-else-if="pageType === 'alex' || organizationSlug==='gala'"
    >
<!--      <div>-->
<!--        <h3 class="mb-5 text-center">My Suggestions </h3>-->
<!--        <p class="mb-base text-center">-->
<!--          Got something interesting to share with everyone? Add it to training library-->
<!--        </p>-->
<!--        <div class="text-center">-->
<!--          <vs-button-->
<!--            color="#dc0032"-->
<!--            style="border-radius: 50px"-->
<!--          >360 Training’s  curated </vs-button-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->
    </vs-card>

    <vs-card
      v-else-if="pageType === 'EMOTIONHACK' || organizationSlug==='emotionhack'"
    >
      <!--      <div>-->
      <!--        <h3 class="mb-5 text-center">My Suggestions </h3>-->
      <!--        <p class="mb-base text-center">-->
      <!--          Got something interesting to share with everyone? Add it to training library-->
      <!--        </p>-->
      <!--        <div class="text-center">-->
      <!--          <vs-button-->
      <!--            color="#dc0032"-->
      <!--            style="border-radius: 50px"-->
      <!--          >360 Training’s  curated </vs-button-->
      <!--          >-->
      <!--        </div>-->
      <!--      </div>-->
    </vs-card>
    <vs-card v-else class="newsletter-card p-5">
      <img
        class="newsletter-leaf"
        src="../../../src/assets/images/leaves/l5.png"
        align="right"
      />
      <div>
        <h3 class="mb-5">Subscribe To Our Newsletter</h3>
        <p class="mb-base">Subscribe to our newsletter and get our update</p>
        <vx-input-group class="newsletter-input-group lg:w-7/12 sm:w-full">
          <vs-input
            icon-pack="feather"
            icon="icon-mail"
            id="newsletter-input"
            v-model="input2"
          />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button :color="alexPage ? '#dc0032' : '#44CC88'"
                >SignUp</vs-button
              >
            </div>
          </template>
        </vx-input-group>
      </div>
    </vs-card>
    <section
      class="container"
      :class="alexPage ? 'section-footer-alex' : 'section-footer'" v-if="organizationSlug==='emotionhack'"
    >
      <vs-row vs-w="12">
        <vs-col
          class="footer-brand"
          :class="{ 'alex-footer': alexPage }"
          vs-justify="center"
          vs-align="center"
          :vs-lg="alexPage ? '4' : '6'"
          vs-sm="6"
          vs-xs="12"
        >
          <h3 class="mb-base "><span  style="color:white">GetBoarded</span></h3>
          <p style="font-size:12px;color:rgba(255, 255, 255, 0.56);" >
            Our mission is to empower the world is professionals to take control
            of their personal brand and become more successful.
          </p>
          <img
            class="m-2 mt-12"
            src="../../../src/assets/images/icons/logo-facebook.svg"
            width="32px"
            height="32px"
            style="border-radius:50%;"
          />
          <img
            class="m-2 mt-12"
            src="../../../src/assets/images/icons/logo-twitter.png"
            width="32px"
            height="32px"
            style="border-radius:50%;"
          />
          <img
            class="m-2 mt-12"
            src="../../../src/assets/images/icons/logo-instagram.svg"
            width="32px"
            height="32px"
            style="border-radius:50%;"
          />
<!--          <img-->
<!--            class="m-2 mt-12"-->
<!--            src="../../../src/assets/images/icons/logo-github.svg"-->
<!--            width="32px"-->
<!--            height="32px"-->
<!--            style="border-radius:50%;"-->
<!--          />-->
        </vs-col>
        <vs-col
          class="footer-col"
          :class="{ 'alex-footer': alexPage }"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          :vs-sm="alexPage ? '3' : '4'"
          vs-xs="12"
        >
          <h5 class="mb-base">Company</h5>
          <ul >
            <li class="mb-3"><a href="#" style="font-size:12px;">Marketing</a></li>
            <li class="mb-3"><a href="#" style="font-size:12px;">Analytics</a></li>
            <li class="mb-3"><a href="#" style="font-size:12px;">Commerce</a></li>
            <li class="mb-3"><a href="#" style="font-size:12px;">Insights</a></li>
          </ul>
        </vs-col>
<!--        <vs-col-->
<!--          class="footer-col"-->
<!--          :class="{ 'alex-footer': alexPage }"-->
<!--          vs-justify="center"-->
<!--          vs-align="center"-->
<!--          vs-lg="2"-->
<!--          :vs-sm="alexPage ? '3' : '4'"-->
<!--          vs-xs="12"-->
<!--        >-->
<!--          <h5 class="mb-base">Partners</h5>-->
<!--          <ul >-->
<!--            <li class="mb-3"><a href="#" style="font-size:12px;">Pricing</a></li>-->
<!--            <li class="mb-3"><a href="#" style="font-size:12px;">Documentation</a></li>-->
<!--            <li class="mb-3"><a href="#" style="font-size:12px;">Guides</a></li>-->
<!--            <li class="mb-3"><a href="#" style="font-size:12px;">API Status</a></li>-->
<!--          </ul>-->
<!--        </vs-col>-->
        <vs-col
          class="footer-col"
          :class="{ 'alex-footer': alexPage }"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          :vs-sm="alexPage ? '3' : '4'"
          vs-xs="12"
        >
          <h5 class="mb-base">Legal</h5>
          <ul>
            <li class="mb-3"><a href="/about-us" style="font-size:12px;">About</a></li>
            <li class="mb-3"><a href="#" style="font-size:12px;">Blog</a></li>
           <li class="mb-3"><a href="#" style="font-size:12px;">Jobs</a></li>
            <li class="mb-3"><a href="#" style="font-size:12px;">Press</a></li>
            <li class="mb-3"><a href="#" style="font-size:12px;">Partners</a></li>
            <!-- <li class="mb-3"><a href="#">Recruiters</a></li> -->
            <!-- <li class="mb-3"><a href="#">Events</a></li> -->
          </ul>
        </vs-col>
        <vs-col
          class="footer-col"
          :class="{ 'alex-footer': alexPage }"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          :vs-sm="alexPage ? '3' : '4'"
          vs-xs="12"
        >
          <h5 class="mb-base">Contact</h5>
          <ul>
            <li class="mb-3"><a href="/about-us" style="font-size:12px;">Claim</a></li>
            <li class="mb-3"><a href="#" style="font-size:12px;">Privacy</a></li>
           <li class="mb-3"><a href="#" style="font-size:12px;">Terms</a></li>
            <!-- <li class="mb-3"><a href="#">Recruiters</a></li> -->
            <!-- <li class="mb-3"><a href="#">Events</a></li> -->
          </ul>
        </vs-col>

      </vs-row>
      <vs-row class="footer-bottom" vs-w="12">
        <vs-col
          class="footer-social"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          :vs-sm="alexPage ? '3' : '4'"
          vs-xs="12"
        >

        </vs-col>
        <vs-col
          class="footer-copyright"
          :style="{ color: alexPage ? 'white' : 'white' }"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
          style="font-size:12px;"
        >
          © {{ new Date().getFullYear() }} GetBoarded INC | <router-link class="text-white" to="/privacy-policy">Privacy </router-link> |
          <router-link class="text-white" to="/cookie-policy">Cookies</router-link> | <router-link class="text-white" to="/terms-of-use">T & C</router-link> | <router-link class="text-white" to="/gdpr-compliance">GDPR Compliance</router-link>
        </vs-col>
      </vs-row>
    </section>
    <section
      class="container"
      v-else

    >

      <vs-row  vs-w="12">

        <vs-col
          class="footer-copyright"
          :style="{ color: alexPage ? 'white' : 'white' }"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
          style="font-size:12px;"
        >
          © {{ new Date().getFullYear() }} GetBoarded INC | <router-link class="text-white" to="/privacy-policy">Privacy </router-link> |
          <router-link class="text-white" to="/cookie-policy">Cookies</router-link> | <router-link class="text-white" to="/terms-of-use">T & C</router-link> | <router-link class="text-white" to="/gdpr-compliance">GDPR Compliance</router-link>
        </vs-col>
      </vs-row>
    </section>
  </footer>
</template>

<script>
import Footer from "../../views/pages/about/about-us-new/Footer";
export default {
  name: "the-footer",
  components: {Footer},
  props: {
    classes: {
      type: String,
    },
  },
  data() {
    return {
      input2: "",
      organizationSlug:'',
      // pageFooterBackgroundColor: this.$store.state.pageFooterBackgroundColor
    };
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    pageType() {
      return this.$store.state.pageType;
    },
    alexPage() {
      if (
        this.$store.state.pageType === "alex" ||
        this.$store.state.pageType === "alex-curate" ||
        this.$store.state.pageType === "alex-customize" ||
        this.$store.state.pageType === "alex-connect"
      ) {
        return true;
      }
      return false;
    },

    organizationName() {

      return this.$store.state.organization.orgData.name;
    },

    pageFooterBackgroundColor() {
      if(this.organizationSlug==='gala'){
        return  this.$store.state.pageFooterBackgroundColor='#000000';
      }
      else if(this.organizationSlug==='emotionhack'){
        return  this.$store.state.pageFooterBackgroundColor='#121127';
      }
      else if(this.organizationSlug==='dpd-belux'){
        return  this.$store.state.pageFooterBackgroundColor="linear-gradient(#DC0032, #DC0032)";
      }else{
        console.log('this.$store.state.pageFooterBackgroundColor;',this.$store.state.pageFooterBackgroundColor);
        return  this.$store.state.pageFooterBackgroundColor;
      }

    },
  },
  created() {
    console.log('this.$route.params',this.$route.path);
    let  url = this.$route.path.split('/');
    this.organizationSlug=url[1];
    console.log('this.$route.params',url);
    const orgSlug =  url[1];
    if (this.isUserLoggedIn) {
      if (orgSlug) {
        this.$store
          .dispatch("organization/fetchOrganizationBySlug", orgSlug)
          .then((res) => {
            console.log('res.data', res.data.data[0]);
            this.organizationSlug = res.data.data[0].slug
            this.organizationName = res.data.data[0].name
            if (!res.data.data[0].activeMarketplace) this.$router.push("/");
            else {
              this.$store.dispatch("journey/fetchUserSegments", {orgId: res.data.data[0]._id});

            }
          })
          .catch((err) => {
            throw err;
          });
      }
    }
    this.boardSlug = url[2];
    this.userId = url[3];
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    showChatPopup() {
      this.$store.commit("alex/SET_CHAT_ID", "YUA5vj6H");
      this.$store.commit("alex/TOGGLE_ALEX_CHAT_MODAL", true);
    },
  },

};
</script>

<style scoped>
.con-vs-card {
  height: auto;
  min-height: auto;
}
.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}
.newsletter-leaf {
  position: absolute;
  right: 0;
  bottom: 0;
  width: auto;
  height: 100%;
  border-bottom-right-radius: 8px;
}
.newsletter-card {
  position: absolute;
  width: 60%;
  top: -100px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
.newsletter-card-gala{
  position: absolute;
  width: 100%;
  top: -100px;
  z-index:1000;
  background: url("../../../src/assets/images/icons/gala/subscription-background.svg");
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}

.newsletter-card--company {
  top: -150px;
}
.newsletter-card h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 28px;
  text-align: left;
  color: #231d4f;
}
.newsletter-card p {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 28px;
  /* identical to box height, or 140% */

  text-align: left;
  letter-spacing: -0.01em;

  color: #848199;
}
.newsletter-input-group >>> input {
  border-radius: 100px 0 0 100px;
  background-color: #f5f5f5;
  border-color: #f5f5f5 !important;
}
.newsletter-input-group >>> i {
  color: #848199 !important;
}

.my-suggestions-card {
  width: 75%;
}
/*.vs-inputx {
    border-top-left-radius: 100px!important;
    border-bottom-left-radius: 100px!important;
  }*/
button {
  border-radius: 0 100px 100px 0;
}
/*===============================================*/
/*  8. FOOTER 	 						 */
/*===============================================*/
/* BLOCK - footer */
.footer {
  position: relative;
  /*background: linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%);*/
  padding: 15rem 10rem 2rem 10rem;
  border-top: 7rem solid white;
}
.footer-brand h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 115%;
  letter-spacing: -0.04em;
  color: #ffffff;
}
.footer-brand p {
  width: 80%;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
}
.footer-col h5 {
  font-style: normal;
  font-weight: bold;
  /*font-size: 16px;*/
  line-height: 15px;
  color: #ffffff;
}
.footer-bottom {
  margin-top: 5rem;
}
.footer-col ul li a {
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 19px;
  color: #ffffff;
}
.footer-copyright {
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 19px;
  text-align: right;
  color: #ffffff;
}

.section-footer {
  width: 94%;
}
.section-footer-alex {
  width: 94%;
}
/* ALEX */

.alex-footer h3 {
  color: #231d4f !important;
}
.alex-footer p {
  color: #ffffff !important;
}
.alex-footer ul li a {
  color: #ffffff !important;
}
.alex-footer h5 {
  color: #ffffff !important;
}
.alex-link-item {
  cursor: pointer;
}
.alex-link-item ::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #ffffff;; /* Change the color */
  font-weight: bold;
  margin-right: 0.5rem;
}

/*===============================================*/
/* MEDIA QUERIES	 						 */
/*===============================================*/

@media (max-width: 1200px) {
  section {
    padding: 5rem 1rem;
    /*background: #FFFFFF;*/
  }
  .newsletter-leaf {
    display: none;
  }
  .newsletter-card {
    width: 80%;
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }

  .newsletter-card h3 {
    line-height: 28px;
  }
  .footer {
    padding: 15rem 1rem 5rem 1rem;
  }
}
</style>
